import { combineEpics } from 'redux-observable';
import getAttributes from './getAttributes';
import getEstimationProducts from './getEstimationProducts';
import getOrderProducts from './getOrderProducts';
import getChannelNodes from './getChannelNodes';

export default combineEpics(getAttributes, getEstimationProducts, getOrderProducts, getChannelNodes);



// WEBPACK FOOTER //
// ./src/application/products/epic/index.ts